export default __webpack_public_path__ + "static/media/img404.f95f429a.png";